export function isOnRequestWithoutPrice(responseString:OnRequestType) {
  return responseString === 'ohne Preis';
}

export type OnRequestType = 'ohne Preis'|'mit Preis';
